import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';
import Banner from '../../components/solutions/healthcare/Banner';
import AISolutions from '../../components/solutions/healthcare/AISolutions';
import CaseStudy from '../../components/solutions/healthcare/CaseStudy';
import HealthcareTransformation from '../../components/solutions/healthcare/HealthcareTransformation';
import Advantage from '../../components/solutions/healthcare/Advantage';
import FooterBanner from '../../components/solutions/healthcare/FooterBanner';

const Healthcare = () => {

  return (
    <>
      <SEO
				title="Healthcare Industry Solutions"
				description="Enhancing Accessibility, Diagnostics, and Real-Time Care through AI-Powered Solutions"
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <Banner />
      <AISolutions />
      <CaseStudy />
      <HealthcareTransformation />
      <Advantage />
      <FooterBanner />
      <FooterOne />
    </>
  )
}

export default Healthcare;